/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector, Provider as ReduxProvider } from 'react-redux';
import { AttrTrackingDebug } from '@unisporkal/attr-tracking/debug';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { withClientOnlyBoundary } from '@unisporkal/federation';
import { ThemeProvider as DeprecatedThemeProvider } from '@unisporkal/themes';
import { UserProvider } from '@unisporkal/user';
import { BoardToolboxProvider } from '@unisporkal/board-toolbox';

const ClientOnlyReactQueryDevtools = withClientOnlyBoundary(
  ReactQueryDevtools,
  {
    appName: 'uni-search',
    componentName: 'ReactQueryDevtools',
  }
);

const ConnectedBoardToolboxProvider = ({ children }) => {
  const assets = useSelector((state) => state.gallery?.assets ?? []);
  const assetIds = assets.map((a) => a.id);

  return (
    <BoardToolboxProvider assetIds={assetIds}>{children}</BoardToolboxProvider>
  );
};

const withProviders = (Component) => {
  const WrappedComponent = ({ site, user, store, ...props }) => (
    <>
      <AttrTrackingDebug
        guard={() =>
          Promise.resolve({
            // Search serves as a POC for the AttrTrackingDebug implementation,
            // In the future the guard will likely involve async checks. For now,
            // with Rails as BFF we simply check if the user has debug permissions
            isAuthorized: props.search?.canDebugTracking || false,
          })
        }
      />

      <ClientOnlyReactQueryDevtools initialIsOpen={false} />
      <ReduxProvider store={store}>
        <UserProvider user={user}>
          <DeprecatedThemeProvider theme={site.nickname}>
            <ConnectedBoardToolboxProvider>
              <Component {...props} />
            </ConnectedBoardToolboxProvider>
          </DeprecatedThemeProvider>
        </UserProvider>
      </ReduxProvider>
    </>
  );

  return WrappedComponent;
};

export default withProviders;
